var common = require("../../utiles/common.js")
var service = require("../../utiles/service")
var layUtils = require("../../utiles/layUtils");

module.exports = {
    register: function () {
        document.createElement('id-shield')
        ko.components.register('id-shield', {
            viewModel: function (params) {
                var $this = this;
                $this.qrcode = ko.observable("");
                $this.qrstr = ko.observable("");
                $this.enable = ko.observable("");
                $this.devices = ko.observableArray(service.idShield.deviceList());
                $this.unbind = function (index) {
                    common.confirmAlert("删除后一些多因子认证将不能使用,确定删除？",function(){
                        var id = $this.devices()[index].id;
                        service.idShield.unbind(id)
                        $this.devices.splice(index, 1);
                    });
                }

                $this.qrcode.subscribe(function (v) {
                    $("#bindQRCode").html("");
                    $this.qrstr(JSON.stringify(v));
                    console.log(v)
                    //张旭说---用当前的地址
                    v.server = window.location.href.split("/#/")[0];
                    new QRCode(document.getElementById("bindQRCode"), JSON.stringify(v));
                });
                $this.toggleEnable = function () {
                    //alert(11111)
                    $this.enable(!$this.enable())
                }
                common.addInterval(function () {
                    $this.qrcode(service.idtoken.qrcode())
                }, 580000);
                $this.qrcode(service.idtoken.qrcode());

                $this.openApple = function(){
                    layUtils.open({
                        title:"请扫描下方二维码下载ID管家！",
                        type: 1, 
                        area:["360px","400px"],
                        content: $("#appleQRCode"),
                    })
                    $("#appleQRCode").html("");
                    new QRCode(document.getElementById("appleQRCode"), "https://apps.apple.com/cn/app/tencent/id1473215382");
                }
            },
            template: require("./template/IdShield.html")
        });
        ko.components.register('id-shield-item', {
            viewModel: function (params) {
                var $this = this;
                $this.parent = params.parent;
                $this.device = params.device;
                $this.index = params.index;
                $this.createdDate = common.selectTimes(new Date().getTime()-360000);
                $this.lastModifiedDate = common.selectTimes(new Date().getTime()-36000);
                $this.enable = ko.observable($this.device.enable);

                $this.toggleEnable = function () {
                    service.idShield.enable({id: $this.device.id, enable: !$this.enable()});
                    console.log($this.device.id)
                    $this.enable(!$this.enable())
                }
            },
            template: require("./template/IdShiledItem.html")
        });

    }
}




//////////////////
// WEBPACK FOOTER
// ./src/component/idShield/IdShield.js
// module id = 129
// module chunks = 0